/**
 * directives/index.js
 *
 * Automatically included in `./src/main.js`
 */
import type { App } from 'vue'

import { mobile, desktop } from './breakpointDirectives'

export function registerDirectives(app: App) {
  app.directive('mobile', mobile)
  app.directive('desktop', desktop)
}
